<div class="container">
  <mat-toolbar class="custom-header">
  <span (click)="closeModal()">
    <mat-icon svgIcon="mat:arrow_back"></mat-icon>
  </span>
</mat-toolbar>
  <h2>{{data.i18nTitle[translate.currentLang.toUpperCase()]}}</h2>
  <img [src]="environmentNode+'/get-recipe-image/'+data._id" alt="">
  <h3>{{"PROFILE.NUTRITION.INGREDIENTS" | translate}}</h3>
  <div class="info-box" *ngFor="let item of data.ingredientsFull | keyvalue">
    <p class="data-label">{{getItem(item).value.i18nName[translate.currentLang]}}</p>
    <p class="data">{{getItem(item).value.quantity}} {{getItem(item).value.unit[translate.currentLang]}}</p>
  </div>
  <h3>{{"PROFILE.NUTRITION.PREPARATION" | translate}}</h3>
  <div [innerHTML]="data.i18nPreparation[translate.currentLang.toUpperCase()]" class="preparation"></div>
</div>
